<div class="layout-topbar">
    <div class="layout-topbar-logo-container">
        <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>
        <a class="layout-topbar-logo" routerLink="/sys/dashboard">
            <img src="./assets/img/logos/Logo_512px.png" alt="Logo" class="h-10 w-auto" />
            <span>ARCO</span>
        </a>
    </div>

    <!-- Usuario en el centro -->
    <div class="layout-topbar-center">
        <div class="user-info">
            <i class="pi pi-user"></i>
            <span class="user-name">{{ nombreUsuario }} - {{ sucursal }}</span>
        </div>

        @if (canSwitchBranch) {
        <div class="branch-selector ml-4">
            <label class="branch-label">Sucursal</label>
            <p-select
                [options]="branches"
                [(ngModel)]="selectedBranch"
                optionLabel="name"
                placeholder="Cambiar sucursal"
                (onChange)="onBranchChange()"
                [loading]="switchingBranch"
            />
        </div>
        }
    </div>


    <div class="layout-topbar-actions">
        <div class="layout-config-menu">
            <!-- <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                <i
                    [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
            </button> -->
            <!-- <div class="relative">
                <button class="layout-topbar-action layout-topbar-action-highlight" pStyleClass="@next"
                    enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden"
                    leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
                    <i class="pi pi-palette"></i>
                </button> -->
            <app-configurator />
            <!-- </div> -->
        </div>

        <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden"
            enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout"
            [hideOnOutsideClick]="true">
            <i class="pi pi-ellipsis-v"></i>
        </button>

        <div class="layout-topbar-menu hidden lg:block">
            <div class="layout-topbar-menu-content">
                @if (rolUser === 'customer' || rolUser === 'admin') {
                <button type="button" class="layout-topbar-action" pTooltip="Carrito Compras" tooltipPosition="left"
                    (click)="goto('/dd/cl/shoppingcart')">
                    <i class="pi pi-shopping-cart"></i>
                    <span>Carrito</span>
                </button>

                <button type="button" class="layout-topbar-action" pTooltip="Favoritos" tooltipPosition="left"
                    (click)="goto('/dd/cl/favorites')">
                    <i class="pi pi-heart"></i>
                    <span>Favoritos</span>
                </button>
                }

                <button type="button" class="layout-topbar-action" pTooltip="Notificaciones" tooltipPosition="left"
                    (click)="goto('/dd/cl/notifications')">
                    <i class="pi pi-inbox"></i>
                    <span>Notificaciones</span>
                </button>

                <button type="button" class="layout-topbar-action" pTooltip="Perfil" tooltipPosition="left"
                    (click)="goto('/sys/profile')">
                    <i class="pi pi-user"></i>
                    <span>Perfil</span>
                </button>

                <button type="button" class="layout-topbar-action" pTooltip="Salir" tooltipPosition="left"
                    (click)="openConfirmation()">
                    <i class="pi pi-fw pi-sign-out"></i>
                    <span>Logout</span>
                </button>
            </div>
        </div>
    </div>
</div>

<p-dialog header="Confirmación" [(visible)]="displayConfirmation" [style]="{ width: '350px' }" [modal]="true">
    <div class="flex items-center justify-center">
        <i class="pi pi-exclamation-triangle mr-4" style="font-size: 2rem"> </i>
        <span>¿Esta seguro que desea cerrar la sesión?</span>
    </div>
    <ng-template #footer>
        <p-button label="No" icon="pi pi-times" (click)="closeConfirmation(false)" text severity="danger" />
        <p-button label="Si" icon="pi pi-check" (click)="closeConfirmation(true)" severity="success" outlined
            autofocus />
    </ng-template>
</p-dialog>